import { deleteSensorGroup } from '@Actions/sensorGroup.action';
import {
	clearStations,
	getFirstLocationFromSensorsRejected,
	getFirstLocationFromSensorsResolved,
	getImagesFromStationRejected,
	getImagesFromStationResolved,
	getSensorGroupsFromStation,
	getSensorGroupsFromStationRejected,
	getSensorGroupsFromStationResolved,
	getSensorsFromStation,
	getSensorsFromStationRejected,
	getSensorsFromStationResolved,
	getSingleStationById,
	getSingleStationByIdRejected,
	getSingleStationByIdResolved,
	getStations,
	getStationsRejected,
	getStationsResolved,
	upsertLiftStation,
	upsertLiftStationRejected,
	upsertLiftStationResolved,
} from '@Actions/stations.action';
import { AnyAction, createReducer } from '@reduxjs/toolkit';
import { StationsStoreState } from '@Types';

export const initialState: StationsStoreState = {
	paginatedStations: undefined,
	initialized: false,
	stationById: { initialized: false },
	sensorGroupsByStationId: { initialized: false },
	sensorsByStationId: { initialized: false },
	imagesByStationId: { initialized: false },
	upsertLiftStation: { status: 'idle' },
};

interface StationsActions {
	[x: string]: (
		state: StationsStoreState,
		action: AnyAction,
	) => StationsStoreState | undefined;
}

const reducer: StationsActions = {
	[clearStations.toString()]: () => initialState,
	[getStations.toString()]: state => state,
	[getStationsResolved.toString()]: (state, action) => ({
		...state,
		paginatedStations: {
			stations: action.payload.liftStations,
			pagination: action.payload.pagination,
			initialized: true,
		},
	}),
	[getStationsRejected.toString()]: state => state,
	[getFirstLocationFromSensorsResolved.toString()]: (state, action) => {
		return {
			...state,
			stationLocation: action.payload,
		};
	},
	[getFirstLocationFromSensorsRejected.toString()]: state => {
		return {
			...state,
			stationLocation: undefined,
		};
	},
	[getSingleStationById.toString()]: state => {
		return {
			...state,
			stationById: {
				initialized: false,
				station: undefined,
			},
		};
	},
	[getSingleStationByIdResolved.toString()]: (state, action) => {
		return {
			...state,
			stationById: {
				initialized: true,
				station: action.payload,
			},
		};
	},
	[getSingleStationByIdRejected.toString()]: state => {
		return {
			...state,
			stationById: {
				initialized: true,
				station: undefined,
			},
		};
	},
	[getSensorsFromStation.toString()]: state => ({
		...state,
		sensorsByStationId: { initialized: false },
	}),
	[getSensorsFromStationResolved.toString()]: (state, action) => ({
		...state,
		sensorsByStationId: {
			initialized: true,
			sensors: action.payload.sensors,
			pagination: action.payload.pagination,
		},
	}),
	[getSensorsFromStationRejected.toString()]: state => ({
		...state,
		sensorsByStationId: { initialized: true, sensors: undefined },
	}),
	[getSensorGroupsFromStation.toString()]: state => ({
		...state,
		sensorGroupsByStationId: { initialized: false },
	}),
	[getSensorGroupsFromStationResolved.toString()]: (state, action) => ({
		...state,
		sensorGroupsByStationId: {
			initialized: true,
			sensorGroups: action.payload.sensorGroups,
			pagination: action.payload.pagination,
		},
	}),
	[getSensorGroupsFromStationRejected.toString()]: state => ({
		...state,
		sensorGroupsByStationId: { initialized: true },
	}),
	[getImagesFromStationResolved.toString()]: (state, action) => ({
		...state,
		imagesByStationId: {
			initialized: true,
			images: action.payload,
		},
	}),
	[getImagesFromStationRejected.toString()]: state => ({
		...state,
		imagesByStationId: { initialized: true, images: undefined },
	}),
	[upsertLiftStation.toString()]: state => ({
		...state,
		upsertLiftStation: { status: 'pending' },
	}),
	[upsertLiftStationResolved.toString()]: state => ({
		...state,
		upsertLiftStation: { status: 'success' },
	}),
	[upsertLiftStationRejected.toString()]: state => ({
		...state,
		upsertLiftStation: { status: 'error' },
	}),
	[deleteSensorGroup.toString()]: state => ({
		...state,
	}),
};

export default createReducer(initialState, reducer);
